/**
 * @file Album Transaction filter reducer.
 */

import {
  UPDATE_FILTER,
  RESET_FILTER,
} from '../actions/album-transactions-filter';
import {
  ALBUM_ACCOUNTS_FILTER,
  ACCOUNTS_LIMIT,
} from '../constants/transactions';

export const initialState = {
  accountsFilter: ALBUM_ACCOUNTS_FILTER.WITH_TRANSACTION_ITEMS,
  limit: ACCOUNTS_LIMIT,
  offset: 0,
};

const albumTransactionsFilterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        ...state,
        ...action.filter,
      };

    case RESET_FILTER:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default albumTransactionsFilterReducer;
